<template>
  <div>
    <CompleteTable
      v-if="!loading"
      :sorted-field="sortedField"
      :data="applicants"
      :sort-mapping="sortMapping"
      :title="'applicants with retrieves'"
      :total="applicantsTotal"
      :fetch-path="'convo/fetchApplicants'"
      :export-path="'lines/export'"
      :filter-path="'convo/filterApplicants'"
      :actions="true"
      @selectedItems="saveSelectedItems"
    >
      <template v-slot="{field}">
        <td
          class="text-end"
        >
          <b-dropdown
            variant="link"
            no-caret
            toggle-class="p-0"
            right
          >
            <template #button-content>
              <i data-feather="more-vertical" />
            </template>
            <div
              class="btn-group dropup dropdown-icon-wrapper d-none d-sm-block"
            >
              <b-dropdown-item @click="changeRetrieve(field, true)">
                <i
                  class="me-50"
                  data-feather="thumbs-up"
                /> Accept retrieve
              </b-dropdown-item>
              <b-dropdown-item @click="changeRetrieve(field, false)">
                <i
                  class="me-50"
                  data-feather="x"
                /> Deny retrieve
              </b-dropdown-item>
              <div class="dropdown-divider" />
              <b-dropdown-item @click="selectedItem = field, $store.dispatch('modals/toggleFormEvaluation', true)">
                <i
                  class="me-50"
                  data-feather="eye"
                /> View form evaluation
              </b-dropdown-item>
              <b-dropdown-item @click="$store.dispatch('modals/toggleFormEvaluation', true)">
                <i
                  class="me-50"
                  data-feather="eye"
                /> View traces
              </b-dropdown-item>
              <div class="dropdown-divider" />
              <b-dropdown-item @click="$router.push({name: 'admin.users.edit', params: { id: field.user_id }})">
                <i
                  class="me-50"
                  data-feather="edit"
                />
                Edit profile
              </b-dropdown-item>
            </div>
          </b-dropdown>
          <a
            href=""
            class="btn btn-icon btn-light-secondary d-block d-sm-none"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasMenu"
            aria-controls="offcanvasBottom"
          ><i
            data-feather="more-vertical"
          /></a>
        </td>
      </template>
      <template #customfilters>
        <div class="mb-1">
          <label
            for="nameseniorcall"
            class="form-label"
          >Candidate</label>
          <input
            type="text"
            class="form-control"
            name="nameseniorcall"
            @change="saveFilter($event.target.value, 'candidate')"
          >
        </div>
        <div class="mb-1">
          <label
            for=""
            class="form-label"
          >Status</label>
          <select
            id=""
            name=""
            class="form-select"
            @change="saveFilter($event.target.value, 'status')"
          >
            <option value="0">
              All applicants
            </option>
            <option value="1">
              Not eligible
            </option>
            <option value="3">
              1st round
            </option>
            <option value="4">
              2nd round
            </option>
            <option value="5">
              Ranked
            </option>
            <option value="6">
              Offered
            </option>
            <option value="7">
              Position accepted
            </option>
          </select>
        </div>
        <div class="mb-1">
          <div class="row">
            <div class="col-6">
              <label
                for="nameseniorcall"
                class="form-label"
              >AVG Grade min.</label>
              <input
                type="number"
                step="0.01"
                class="form-control"
                name="nameseniorcall"
                @change="saveFilter($event.target.value, 'avg_min')"
              >
            </div>
            <div class="col-6">
              <label
                for="nameseniorcall"
                class="form-label"
              >AVG Grade max</label>
              <input
                type="number"
                step="0.01"
                class="form-control"
                name="nameseniorcall"
                @change="saveFilter($event.target.value, 'avg_max')"
              >
            </div>
          </div>
        </div>
      </template>
      <template #info-sheet-item>
        <div class="offcanvas-body offcanvas-body--view">

          <h4 class="mb-2">
            <strong class="text-success">{{ selectedItems.length }}</strong> selected applicants
          </h4>

          <ul
            id="basic-list-group"
            class="list-group"
          >
            <li class="list-group-item draggable">
              <div class="d-flex">
                <div class="more-info">
                  <div class="form-check">
                    <input
                      id="tableAction1"
                      v-model="actions.moveRoundZero"
                      type="checkbox"
                      class="form-check-input"
                    >
                    <label
                      class="form-check-label"
                      for="tableAction1"
                    >Move to round 0</label>
                  </div>
                </div>
              </div>
            </li>
            <li class="list-group-item draggable">
              <div class="d-flex">
                <div class="more-info">
                  <div class="form-check">
                    <input
                      id="tableAction1"
                      v-model="actions.moveRoundOne"
                      type="checkbox"
                      class="form-check-input"
                    >
                    <label
                      class="form-check-label"
                      for="tableAction1"
                    >Move to round 1</label>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="offcanvas-footer mt-auto">
          <a
            href="#"
            title="apply actions"
            class="btn btn-primary mb-1 d-grid w-100"
            @click="applyActions"
          >Apply actions</a>
        </div>
      </template>
    </CompleteTable>
    <ShowFormEvaluation :selected="selectedItem" />
    <div
      v-if="loading"
      id="loading-bg"
    >
      <div
        class="loading"
      >
        <div class="effect-1 effects" />
        <div class="effect-2 effects" />
        <div class="effect-3 effects" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CompleteTable from '@/views/back/partials/components/CompleteTable.vue'
import { BDropdown, BDropdownItem } from 'bootstrap-vue'
import Vue from 'vue'
import ShowFormEvaluation from './ShowFormEvaluation.vue'

export default {
  components: {
    CompleteTable,
    BDropdown,
    BDropdownItem,
    ShowFormEvaluation,
  },
  props: {
    status: { type: Number, required: false, default: () => null },
  },
  data() {
    return {
      sortedField: 'Name',
      defaultFields: [
        {
          name: 'Name',
          checked: true,
          order: 1,
        },
        {
          name: 'Area',
          checked: true,
          order: 2,
        },
        {
          name: 'ERC',
          checked: true,
          order: 3,
        },
        {
          name: 'Institution',
          checked: true,
          order: 4,
        },
        {
          name: 'Author',
          checked: true,
          order: 5,
        },
        {
          name: 'Evaluators',
          checked: true,
          order: 6,
        },
        {
          name: 'Reason',
          checked: true,
          order: 7,
        },
        {
          name: 'Traces',
          checked: true,
          order: 8,
        },
        {
          name: 'Decision',
          checked: true,
          order: 9,
        },
        {
          name: 'Status',
          checked: true,
          order: 10,
        },
      ],
      sortMapping: {
        Name: 'full_name',
        Area: 'area',
        ERC: 'erc',
        Institution: 'institution',
        Evaluators: 'evaluators',
        Reason: 'retrieve.reason',
        Traces: 'traces',
        Decision: 'retrieve.answer',
        Author: 'retrieve.evaluator.name',
        Status: 'status.status_table',
      },
      actions: {
        moveRoundZero: false,
        moveRoundOne: false,
      },
      selectedItems: [],
      selectedItem: {},
      loading: true,
    }
  },
  computed: {
    ...mapGetters({
      convo: 'convo/convo',
      applicants: 'convo/applicants',
      applicantsTotal: 'convo/applicantsTotal',
      fields: 'modals/tableSettingsFields',
    }),
  },
  async mounted() {
    this.$store.dispatch('modals/fetchUserFields', 'retrieves_table')
    await this.$store.dispatch('convo/fetchApplicants', { id: this.$route.params.id, status: { value: 997 } })
    this.loading = false

    if (!this.fields || this.fields.length === undefined) { // If user doesnt have default fields, load the true default
      await this.$store.dispatch('modals/fetchFields', {
        fields: this.defaultFields,
        table: 'retrieves_table',
      })
    }
    setTimeout(() => {
      feather.replace({
        width: 14,
        height: 14,
      })
    }, 500)
  },
  methods: {
    async changeRetrieve(applicant, answer) {
      await Vue.prototype.$http.post(`${Vue.prototype.$groupUrl}/convo/update/update-retrieve`, {
        retrieve_id: applicant.retrieve.id,
        answer,
      })

      this.$store.dispatch('convo/fetchApplicants', { id: this.$route.params.id, status: { value: 997 } })

      this.$toast.success('Retrieve status successfully changed!')
    },
    applyActions() {
      if (this.selectedItems.length > 0) {
        Vue.swal({
          title: 'Perform the following actions on the selected publications?',
          html: this.getActionsString(),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Yes, apply!',
        }).then(result => {
          if (result.isConfirmed) {
            const itemIds = this.selectedItems.map(el => el.id)
            this.$store.dispatch('payrolls/downloadZip', { itemIds }).then(() => {
              this.$store.dispatch('payrolls/filter')
              this.$toastr.success('', 'Actions applied successfully!')
              this.selectedItems = []
              this.$store.dispatch('modals/toggleInfoItemSheet', false)
            })
          }
        })
      } else {
        this.$toastr.error('', 'No items selected!')
      }
    },
    getActionsString() {
      let str = ''

      if (this.actions.moveRoundZero) {
        str += '<p class="text-success">Move the selected applicants to Round 0</p>'
      }

      if (this.actions.moveRoundOne) {
        str += '<p class="text-success">Move the selected applicants to Round 1</p>'
      }

      return str
    },
    saveSelectedItems(items) {
      this.selectedItems = items
    },
  },
}
</script>
